<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width ? options.width : 650"
    persistent
    scrollable
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-card-title class="pa-0" v-if="!(options && options.custom)">
        <v-toolbar dark :color="options.toolbarColor || 'secondary'" flat>
          <v-toolbar-title v-html="options.title || title"></v-toolbar-title>
          <v-spacer />
          <v-btn icon dark @click="onClose" v-if="!(options && options.persist)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text :class="[options.custom ? 'border-top-studi' : '']">
        <slot name="content">
          <v-row class="my-1">
            <v-col cols="2" v-if="options.withIcon">
              <v-avatar :color="options.avatarColor || '#FFE6E6'" size="64">
                <v-icon :color="options.iconColor || 'error'">
                  {{ options.icon || `mdi-alert` }}
                </v-icon>
              </v-avatar>
            </v-col>
            <v-col cols="3" v-else-if="options.withImage">
              <v-img src="https://penggerak-cdn.siap.id/s3/sekolahpenggerak/img/img-alert.png"></v-img>
            </v-col>
            <v-col :cols="options.withIcon || options.withImage ? 9 : 12">
              <div v-html="message"></div>
            </v-col>
          </v-row>
        </slot>
      </v-card-text>
      <template v-if="(options && options.useBtn) || !((options && options.persist) || false)">
        <v-divider></v-divider>
        <v-card-actions>
          <slot name="action">
            <v-spacer></v-spacer>
            <v-btn
              :color="(notif && notif.color) || (options && options.btnActionColor) || '#26a69a'"
              dark
              depressed
              @click="onAction"
              v-if="(options && options.useBtn) || (notif && notif.action)"
            >
              <v-icon v-if="(notif && notif.btnActionIcon) || (options && options.btnActionIcon)" left>
                {{ (notif && notif.btnActionIcon) || (options && options.btnActionIcon) }}
              </v-icon>
              {{ (notif && notif.button) || (options && options.btnActionLabel) }}
            </v-btn>
            <v-btn class="ma-2" :color="options.btnColor || '#26a69a'" dark @click="onClose" v-else>
              {{ (options && options.btnLabel) || 'OK' }}
            </v-btn>
            <v-btn v-if="options && options.useClose" class="ma-2" color="grey" dark @click="onClose">
              Tutup
            </v-btn>
          </slot>
        </v-card-actions>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'PopupNotifikasi',
  data() {
    return {
      dialog: false,
      title: 'Pengumuman',
      message: '',
      options: {},
    };
  },
  props: {
    notif: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    open(message, title, options) {
      this.title = title || this.title;
      this.message = message || this.message;
      this.options = options || this.options;
      this.dialog = true;
    },
    onClose() {
      this.dialog = false;
      if (this.options && this.options.action) this.options && this.options.action();
    },
    onAction() {
      this.$nextTick(() => {
        this.dialog = false;
        if (this.notif && this.notif.action) this.$emit('action', this.notif.action);

        if (this.options && this.options.btnActionFunc) this.options.btnActionFunc();
      });
    },
  },
};
</script>

<style>
.border-top-studi {
  border-top: 7px solid #00bfa5;
}

/* global table */
.tbl-form .big,
.tbl-data .big {
  font-size: 18px;
}
.tbl-data,
.tbl-form {
  border-collapse: collapse;
  width: 100%;
  font-size: 14px;
}
.tbl-data th,
.tbl-data td {
  padding: 7px;
}
.tbl-form td {
  padding: 0;
}
.tbl-data th,
.tbl-data td {
  border-bottom: 1px solid #e9e9e9;
}
.tbl-form th,
.tbl-form td {
  border-bottom: none;
}
.tbl-data th,
.tbl-form th,
.tbl-data tfoot td {
  color: #ffffff;
}
/* table caption */
.tbl-data > caption {
  background: #e6eeed;
  display: table-caption;
  padding: 10px;
  border-bottom: 1px solid #c7e6e4;
  font: 16px 'Helvetica neue', Helvetica, Arial, sans-serif;
  text-align: left;
}
/* application table */
.tbl-data > thead > tr > th,
.tbl-data > tfoot > tr > td {
  /*background-color: #f3f3f3;*/
  background-color: #2196f3;
}
.tbl-data > tbody > tr.selected > th,
.tbl-data > tbody > tr:hover > th {
  background-color: #e0e0e0;
}
.tbl-data > tbody > tr.selected,
.tbl-data > tbody > tr:hover {
  background-color: #ffffcc;
}
/* application table edit mode */
.tbl-data.editmode > tbody > tr.selected,
.tbl-data.editmode > tbody > tr:hover {
  background-color: #ffffcc;
}
.tbl-data.editmode th.check:first-child,
.tbl-data.editmode > thead > tr > th:first-child,
.tbl-data.editmode > tbody > tr > td:first-child {
  padding-right: 0;
}
/* form table */
.tbl-form > thead > tr > th {
  background-color: #eef4e5;
}
/* editable cell */
.tbl-data > tbody > tr.selected > th {
  font-weight: bold !important;
}
/* other
.tbl-data td.no:before{
	font-size:16px;
	font-weight:bold;
} */
.tbl-data tr > .noed,
.tbl-data tr > .no {
  padding-right: 0;
  text-align: right;
}
.tbl-data .noed-start {
  counter-reset: nomer;
}
.tbl-data .noed {
  counter-increment: nomer;
}
.tbl-data td.noed:before {
  content: counter(nomer);
  color: #999;
}
.tbl-form .act {
  text-align: center !important;
}
.tbl-form > tr:hover > .nohov {
  background: none;
}
.tbl-form .number {
  text-align: right;
  width: 50px;
}
.tbl-form .num-2digit {
  text-align: right;
  width: 30px;
}
/* table */
tbody.fl {
  margin-right: 20px;
}
tbody.fl:last-child {
  margin-right: 0;
}
table.vt td {
  vertical-align: top;
}
table.vm td {
  vertical-align: middle;
}

.tbl-data tr:nth-child(odd) {
  background-color: #ffffff;
}

.tbl-data tr:nth-child(even) {
  background-color: #f3f3f3;
}
</style>
